import { If } from '@itau-loans-www/components'

import Simulator from './components/Simulator/simulator'
import './lp-simulation.scss'

const Simulation = ({
  content: { title = '', description = '', list = [], cta },
  showHelperText = true
}) => {
  return (
    <section className="lp-simulation">
      <div className="lp-simulation__container">
        <div className="lp-simulation__col">
          <h3
            className="lp-simulation__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p className="lp-simulation__text">{description}</p>
          <div className="lp-simulation__items">
            {list.map(({ text }, index) => (
              <p
                className="lp-simulation__items-text"
                key={index}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            ))}
          </div>
        </div>
        <div className="lp-simulation__col">
          <Simulator cta={cta} />

          <If
            condition={showHelperText}
            renderIf={
              <p className="lp-simulation__disclaimer">
                Não sabe seu saldo? Consulte no app{' '}
                <a
                  target="_blank"
                  rel="noreferrer nofollow"
                  href="https://www.caixa.gov.br/atendimento/aplicativos/fgts/Paginas/default.aspx"
                >
                  FGTS Caixa
                </a>
              </p>
            }
          />
        </div>
      </div>
    </section>
  )
}

export default Simulation
